import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";

import AdmissionList from "../../components/AdmissionsList/AdmissionList";
import * as actionTypes from "../../store/actions/actionTypes";
import {bookingListSet} from "../../store/actions/bookingList";
import BookingList from "../../components/BookingList/BookingList";

const BookingListView = () => {
    const dispatch = useDispatch();
    const bookingListVars = useSelector(state => state.bookingList);
    const selectedHospital = useSelector(state => state.auth.selectedHospital);
    const params = useParams();
    const {hospitalId, status, keyword, sortColumn, sortMode, filter, page} = params;

    useEffect(() => {
        // console.log('[AdmissionsListView] useEffect()');
        dispatch({type: actionTypes.MENU_BOOKING_LIST});
        dispatch(bookingListSet(hospitalId, status, keyword, filter, page, sortColumn, sortMode));
    }, [
        params.status, params.keyword
    ]);

    return (
        <>
            <BookingList />
        </>
    );
}

export default BookingListView;